var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09091 0V1.54545H13.1364L17.7727 6.18182H30.9091V4.63637L18.5455 4.63636L13.9091 0H3.09091ZM1.54545 3.09091V4.63636H11.5909L16.2273 9.27273H32.4545V7.72727H17L12.3636 3.09091H1.54545ZM0 32.4545V6.18182H10.8182L15.4545 10.8182L34 10.8182V32.4545L27.8182 32.4545V23.1818H6.18182V32.4545H0ZM7.72727 34V24.7273H26.2727V34H23.1818V27.8182H10.8182V34H7.72727ZM12.3636 29.3636V32.4545H21.6364V29.3636H12.3636Z",
    fill: "{current}"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/Explore.7ff7351f3869b23e8a2ebaba40b54a73.svg";
export { ForwardRef as ReactComponent };